import { useEffect } from "react";
import {
  Select,
  Box,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";

type ColumnMappingProps = {
  columns: string[];
  onAgentSelect: (v: string) => void;
  onHHSelect: (v: string) => void;
  selectedAgent: string | undefined;
  selectedHH: string | undefined;
};

export default function ColumnMapping({columns, onAgentSelect, onHHSelect, selectedHH, selectedAgent}:ColumnMappingProps) {
  console.log("columns", columns)
  useEffect(() => {
    if (columns.includes("Agent Email")) {
      onAgentSelect("Agent Email");
    }
    if (columns.includes("Household ID")) {
      onHHSelect("Household ID");
    }
  }, []);

  return (
    <Box sx={{ border: "1px solid #ededed", padding: 2, borderRadius: 2 }}>
      <Stack>
        <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
          Column Mapping
        </Typography>
        <Stack flexDirection="row" gap={2}>
          <Stack width="100%" gap={1}>
            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography style={{ fontSize: 12 }}>Household ID</Typography>
              <ColorHelper color="#86cffc" />
            </Stack>
            <FormControl fullWidth>
              <InputLabel id="column-b-label">Select Column</InputLabel>
              <Select
                labelId="column-b-label"
                label="Select Column"
                onChange={(e) => onHHSelect(e.target.value as string)}
                value={selectedHH ?? ""}
              >
                {columns.map((col, idx) => (
                  <MenuItem value={col} key={idx}>
                    {col}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack width="100%" gap={1}>
            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography style={{ fontSize: 12 }}>Agent Email</Typography>
              <ColorHelper color="#8fffc7" />
            </Stack>
            <FormControl fullWidth>
              <InputLabel id="column-a-label">Select Column</InputLabel>
              <Select
                labelId="column-a-label"
                label="Select Column"
                onChange={(e) => onAgentSelect(e.target.value as string)}
                value={selectedAgent ?? ""}
              >
                {columns.map((col, idx) => (
                  <MenuItem value={col} key={idx}>
                    {col}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}

const ColorHelper = styled.div<{ color: string }>`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background: ${({color}) => color};
    border: 1px solid #ededed;
`;